import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import iconPath from "./../../../../helpers/iconHelper";
import { getlanguagelist } from "../../../../helpers/changelanguage";

function rand() {
  return Math.round(Math.random() * 20) - 10;
}

function getModalStyle() {
  const top = 45;
  const left = 45;

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

const useStyles = makeStyles(theme => ({
  paper: {
    position: 'absolute',
    width: 600,
    backgroundColor: theme.palette.background.paper,
    border: '0',
    boxShadow: theme.shadows[12],
   
  },
}));

export default function ViewmoreModal(props) {
 
  const classes         = useStyles();
  const [modalStyle]    = React.useState(getModalStyle);
  const [open, setOpen] = React.useState(false);
  const modalOpen       = props.modalOpen;
  const viewmoreData    = props.viewmoreData;
  const viewControl     = props.viewControl;
  const page            = props.page;
  
  const handleOpen = () => {
   // setOpen(true);
  };

  const handleClose = () => {
    //setOpen(false);
    props.handleClose();
  };
  const deleteRow = (id,type) => {
    props.deleteRow(id,type);
  }
  let  languagelist    = getlanguagelist();
  return (
    
    <Modal
    aria-labelledby="simple-modal-title"
    aria-describedby="simple-modal-description"
    open={modalOpen}
    onClose={handleClose}
    >
      <div style={modalStyle} className={`popup_list ${classes.paper}`} >
       
            <h4 className="popup_list-title">{props.viewmoreTitle}  </h4>
           
            <div className="clearfix"></div>
           <div className="popup_inner">
           
            {   
                (viewmoreData).map((relation,index) => {
                    return (
                      <div className={(relation.membership == 'GOLD') ? 'relation_user golden_m' : 'relation_user'}  key={`viewmore${index}`} id={`popup${props.viewmoreTitle}${relation.id}`}>
                          <div><img src={(relation.media_link != '') ? relation.media_link : iconPath['DEFAULTUSER']} /></div>
                          <div className="relation_user_info">
                               <h4>{relation.full_name}</h4>
                              <p>{relation.value}</p>
                          </div>
                          {(viewControl == true) ?
                            <div className="popup_action">
                                {(page == 'edit') ?
                                   <button data-toggle="tooltip" title={languagelist.delete} className="pull-left" onClick={()=>deleteRow(relation.id,props.viewmoreTitle)}><i className="fa fa-trash" aria-hidden="true"></i></button>
                                  : null
                                }
                             {/*  <button><i className="fa fa-trash-o" aria-hidden="true"></i></button> */}
                             
                             <button data-toggle="tooltip" title={languagelist[relation.privacy]}><img  className="globe" src={(relation.privacy != '') ? iconPath[relation.privacy] : iconPath['ME']}/></button> 
                             
                              {/* <div className="clearfix"></div> */}
                            </div>
                          : null }
                      </div>
                    )
                })
            }
           
        
           </div>
      </div>
    </Modal>
     
  
  );
}
